import { Directive, Output , HostListener, ElementRef, EventEmitter } from '@angular/core';
import { ExpertLocalOptions } from './expert-local-options.component';

@Directive({
  selector: '[localPlaceholderNullOnClick]'
})

export class LocalPlaceholderNull {
   constructor(private _elementRef : ElementRef , private expertLocOptions : ExpertLocalOptions) {
    }

    @Output()
    public localPlaceholderNullOnClick = new EventEmitter();

 /* To capture all clicks on the host element of the document and 
 check if the click is inside or outside of the element*/
    @HostListener('document:click', ['$event','$event.target'])
    public onClick(event: MouseEvent, targetElement:HTMLElement) {
        if(!this._elementRef.nativeElement.contains(targetElement))
        {   
            this.expertLocOptions.expertLocalOptions="";
        }
    }



}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-local-options/expert-local-placeholder-null.ts